import Default from '@app/constants';
import { FilterEvLockers } from '@app/typings/services/winnonie/evlockers';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';

const filterEvLockersBrand: string = 'winnonie/brand/evLockers.filters';
const filterEvLockersProject: string = 'winnonie/project/evLockers.filters';

const defaultBrandLevel = Default.filter.winnonie.evLockersBrandLevel;
const defaultProjectLevel = Default.filter.winnonie.evLockersProjectLevel;

export const setFilterEvLockersBrandWinnonie = (value: FilterEvLockers) => {
  set(filterEvLockersBrand, value);
};

export const getFilterEvLockersBrandWinnonie = (): FilterEvLockers => {
  return (
    get(filterEvLockersBrand) || {
      filters: defaultBrandLevel,
      pages: Default.pages,
    }
  );
};

export const clearFilterEvLockersBrandWinnonie = () => {
  return set(filterEvLockersBrand, {
    filters: defaultBrandLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterEvLockersBrandWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};

export const setFilterEvLockersProjectWinnonie = (value: FilterEvLockers) => {
  set(filterEvLockersProject, value);
};
export const getFilterEvLockersProjectWinnonie = (): FilterEvLockers => {
  return (
    get(filterEvLockersProject) || {
      filters: defaultProjectLevel,
      pages: Default.pages,
    }
  );
};
export const clearFilterEvLockersProjectWinnonie = () => {
  return set(filterEvLockersBrand, {
    filters: defaultProjectLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterEvLockersProjectWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
